import { Box, Typography, useTheme } from "@mui/material";
import { Trash } from "@phosphor-icons/react";

interface DeletedEntityMessageProps {
  entityType: "chatbot" | "agent" | "form";
  entityName?: string;
}

export function DeletedEntityMessage({
  entityType,
  entityName,
}: DeletedEntityMessageProps) {
  const theme = useTheme();
  const { semanticColors } = theme;

  const labelMap: Record<string, string> = {
    chatbot: "Chatbot",
    agent: "Agent",
    form: "Interface",
  };

  const label = labelMap[entityType] || entityType;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        gap: 1.5,
        padding: 3,
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: "50%",
          backgroundColor: "rgba(240, 68, 56, 0.08)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Trash size={24} color="#F04438" weight="duotone" />
      </Box>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "14px",
          color: semanticColors?.textPrimary || "#344054",
        }}
      >
        {label} has been deleted
      </Typography>
      {entityName && (
        <Typography
          sx={{
            fontSize: "13px",
            color: semanticColors?.textSecondary || "#667085",
            maxWidth: "240px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          &quot;{entityName}&quot;
        </Typography>
      )}
      <Typography
        sx={{
          fontSize: "12px",
          color: semanticColors?.textTertiary || "#98A2B3",
          maxWidth: "260px",
        }}
      >
        The original {label.toLowerCase()} no longer exists. You can remove this
        widget from the dashboard.
      </Typography>
    </Box>
  );
}
